/**
 * @file: 取消选择驱动
 * @author: xiaolong.huang@dmall.com
 */

import ShortCutKey from '../../interaction/shortcutkey/index';
import Select from '../../interaction/select/index';

function init(): void {
    // 鼠标左键按下取消
    ShortCutKey.on({
        keyName: 'mousedown+mouseleft',
        callback: (ev: JQuery.MouseDownEvent): void => {
            Select.downCancel(ev);
        }
    });

    // 鼠标左键抬起取消
    ShortCutKey.on({
        keyName: 'mouseup+mouseleft',
        callback: (ev: JQuery.MouseUpEvent): void => {
            Select.upCancel(ev);
        }
    });

    // 鼠标右键按下取消
    ShortCutKey.on({
        keyName: 'mousedown+mouseright',
        callback: (ev: JQuery.MouseDownEvent): void => {
            Select.downCancel(ev);
        }
    });

    // 应用退出到后台时，取消图纸所有组件的选中态
    // ShortCutKey.on({
    //     keyName: 'appToBackground',
    //     callback: (ev): void => {
    //         Select.clear();
    //         Select.panelSelectAsync();
    //     }
    // });

    // 取消所有选择
    ShortCutKey.on({
        keyName: 'press+esc',
        callback: (ev): void => {
            Select.clear();
            Select.panelSelectAsync();
        }
    });
    ShortCutKey.on({
        keyName: 'command+d',
        callback: (ev): void => {
            Select.clear();
            Select.panelSelectAsync();
        }
    });
}

export default {
    init
};
